import { IsEmpty, passwordStrength } from "../../utils/helper";

export default function IsValidChangePasswordData(data) {
  let errors = {};
  // Regex to detect any whitespace character (space, tab, etc.)
  const spaceRegex = /\s/;

  if ('current_password' in data) {
    if (IsEmpty(data?.current_password)) {
      errors.current_password = "Current Password is required";
    } else if (spaceRegex.test(data.current_password)) {
      errors.current_password = "Password cannot contain spaces";
    }
  }

  if ('new_password' in data) {
    if (IsEmpty(data?.new_password)) {
      errors.new_password = "Password is required";
    } else if (spaceRegex.test(data.new_password)) {
      errors.new_password = "Password cannot contain spaces";
    } else if (data?.new_password.length < 6 || data?.new_password.length > 15) {
      errors.new_password = "Password must be between 6 and 15 characters";
    } else {
      let strength = passwordStrength(data?.new_password);
      if (strength !== 'STRONG') errors.new_password = strength;
    }
  }

  if ('confirm_password' in data) {
    if (IsEmpty(data?.confirm_password)) {
      errors.confirm_password = "Confirm Password is required";
    } else if (spaceRegex.test(data.confirm_password)) {
      errors.confirm_password = "Password cannot contain spaces";
    } else if (data?.new_password !== data?.confirm_password) {
      errors.confirm_password = "Passwords do not match";
    }
  }

  return {
    isValid: IsEmpty(errors),
    errors: errors,
  };
}